import React, { useState, useEffect } from 'react';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';

export const useToggleDetailsButton = (isOpenByDefault = false) => {
  const [isDetailsExpanded, setIsDetailsExpanded] = useState(isOpenByDefault);

  const toggleDetails = () => setIsDetailsExpanded(state => !state);

  useEffect(() => {
    setIsDetailsExpanded(isOpenByDefault);
  }, [isOpenByDefault]);

  return {
    ToggleDetailsButton,
    toggleDetails,
    isDetailsExpanded,
  };
};

function ToggleDetailsButton({ toggleDetails, isDetailsExpanded, useIconView }) {
  if (useIconView) {
    return (
      <button
        className="mn_toggleIcon"
        onClick={toggleDetails}
        aria-label={isDetailsExpanded ? 'Hide offer details' : 'View offer details'}
        aria-expanded={isDetailsExpanded}
      />
    );
  }

  return (
    <button className="mn_basicButton mn_toggleButton" onClick={toggleDetails} aria-expanded={isDetailsExpanded}>
      {isDetailsExpanded ? <>Hide offer details</> : <>View offer details</>}
    </button>
  );
}

export default (props) => <ComponentErrorBoundary><ToggleDetailsButton {...props} /></ComponentErrorBoundary>;
